import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const PublicRoute = ({ children }) => {
  const token = Cookies.get("Orbit_Token");

  return token ? <Navigate to="/home" replace /> : children;
};

export default PublicRoute;
